<template>
  <c-button
    v-bind="$attrs"
    ref="filter"
    flat
    :icon-size="computedIsMobile ? 24 : 20"
    icon="filter-sort-menu"
    :class="buttonClasses"
    :style="{ '--width': pxWidth, '--icon-margin': pxIconMargin }"
    :notifications="mobileNotifications"
    @click="$emit('click', $event)"
  >
    <template v-if="!computedIsMobile">
      <div class="content">
        <span class="filter-text">
          <slot>filtrar</slot>
        </span>
      </div>
    </template>

    <template
      v-if="!computedIsMobile"
      #raw
    >
      <span class="counter" :class="noFilter ? '' : 'has-filter'">
        {{counter}}
      </span>
    </template>
  </c-button>
</template>

<script>
import { MediaQuery } from '@convenia/mixins'
import { is } from '@convenia/helpers'
import CButton from '@convenia/components/CButton'

export default {
  name: 'CFilterButton',

  mixins: [ MediaQuery ],

  components: {
    CButton
  },

  props: {
    counter: {
      type: Number,
      default: 0,
    },

    iconMargin: {
      type: [ String, Number ],
      default: '35px'
    },

    width: {
      type: [ String, Number ],
      required: true
    },

    mobile: {
      type: Boolean,
      default: null
    }
  },

  computed: {
    noFilter () {
      return this.counter <= 0
    },

    buttonClasses () {
      return [
        'c-filter-button',
        {
          '-icon-only': this.computedIsMobile,
          '-has-mobile-counter': this.computedIsMobile && this.counter > 0
        }
      ]
    },

    mobileNotifications () {
      if (!this.computedIsMobile || this.counter <= 0) {
        return {}
      }

      return { count: this.counter, showOnlyHover: false }
    },

    pxWidth () {
      const { width } = this
      return is(width, 'Number')
        ? `${width}px`
        : width
    },

    pxIconMargin () {
      const { iconMargin } = this
      return is(iconMargin, 'Number')
        ? `${iconMargin}px`
        : iconMargin
    },

    computedIsMobile () {
      return this.mobile ?? this.isMobile
    }
  }
}
</script>

<style lang="scss">
.c-filter-button.c-button {
  & > .counter {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);

    background-color: color-var(text, base-10);
    height: 25px;
    width: 32px;

    @include typo(h3);
    color: color-var(text, base-30);

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13px;

    &.has-filter {
      background-color: color-var(positive);
      color: #FFF;
      opacity: 1;

      &::before {
        position: absolute;
        content: '';
        bottom: 0;
        left: 50%;
        width: 68.75%;
        height: 60%;
        border-radius: 50px;
        background: $positive-color;
        transform: translateX(-50%);
        z-index: -$z-index-1;
        opacity: 0.5;
        filter: blur(7px) brightness(1);
      }
    }
  }

  @include responsive (tablet, desktop) {
    justify-content: flex-start;
    width: var(--width);
    padding-left: var(--icon-margin);
  }

  &.-icon-only {
    width: auto;
    padding-left: 0;
    justify-content: center;
  }

  &.-has-mobile-counter {
    margin-right: 8px;

    & > .badge-container > .badge {
      background: color-var(positive);
      box-shadow: 0px 9px 13px -6px rgba(color-var(positive, base-rgb), 0.5);
    }
  }
}
</style>
